/**
 * @fileoverview GET handler for the "/engagement/product_recommender_names" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementProductRecommenderNames } from "./constants";
import type { EngagementProductRecommenderNamesResult, GetEngagementProductRecommenderNamesParams } from "./types";

export const getEngagementProductRecommenderNames = reactQueryFetcherAdapter(
  engagementProductRecommenderNames,
  (
    signal: AbortSignal,
    params: GetEngagementProductRecommenderNamesParams
  ): Promise<EngagementProductRecommenderNamesResult> => {
    return fetch("/engagement/product_recommender_names", "GET", params, { signal });
  }
);
